// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fc-modal__overlay {\n  -webkit-backdrop-filter: blur(3px) saturate(0.66);\n  backdrop-filter: blur(3px) saturate(0.66);\n  background: rgba(0, 0, 0, 0.5);\n  transition: all 50ms ease-in-out;\n}\n.fc-modal__container {\n  max-height: calc(100% - 2rem);\n}\n", ""]);
// Exports
module.exports = exports;
